/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiListSelectorGroup
 */
export interface InternalApiListSelectorGroup {
    /**
     * 
     * @type {string}
     * @memberof InternalApiListSelectorGroup
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiListSelectorGroup
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiListSelectorGroup
     */
    selectorCode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiListSelectorGroup
     */
    subscribedSelectorOptions: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiListSelectorGroup
     */
    enabledSelectorOptions: Array<string>;
}

/**
 * Check if a given object implements the InternalApiListSelectorGroup interface.
 */
export function instanceOfInternalApiListSelectorGroup(value: object): value is InternalApiListSelectorGroup {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('selectorCode' in value) || value['selectorCode'] === undefined) return false;
    if (!('subscribedSelectorOptions' in value) || value['subscribedSelectorOptions'] === undefined) return false;
    if (!('enabledSelectorOptions' in value) || value['enabledSelectorOptions'] === undefined) return false;
    return true;
}

export function InternalApiListSelectorGroupFromJSON(json: any): InternalApiListSelectorGroup {
    return InternalApiListSelectorGroupFromJSONTyped(json, false);
}

export function InternalApiListSelectorGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiListSelectorGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'code': json['code'],
        'selectorCode': json['selectorCode'],
        'subscribedSelectorOptions': json['subscribedSelectorOptions'],
        'enabledSelectorOptions': json['enabledSelectorOptions'],
    };
}

export function InternalApiListSelectorGroupToJSON(json: any): InternalApiListSelectorGroup {
    return InternalApiListSelectorGroupToJSONTyped(json, false);
}

export function InternalApiListSelectorGroupToJSONTyped(value?: InternalApiListSelectorGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'selectorCode': value['selectorCode'],
        'subscribedSelectorOptions': value['subscribedSelectorOptions'],
        'enabledSelectorOptions': value['enabledSelectorOptions'],
    };
}

